__turbopack_context__.v({
  "Caption": "index-module__9I6HFG__Caption",
  "Indicator": "index-module__9I6HFG__Indicator",
  "Item": "index-module__9I6HFG__Item",
  "Radio": "index-module__9I6HFG__Radio",
  "RadioGroup": "index-module__9I6HFG__RadioGroup",
});
